export function getStorageKey<T>(key: string): T | null {
  const value = sessionStorage.getItem(key);
  if (value) return JSON.parse(value);
  return null;
}

export function setStorageKey(key: string, value: Parameters<typeof JSON.stringify>[0]) {
  sessionStorage.setItem(key, JSON.stringify(value));
}
